import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {LineByTimeInsight, LineByTimeInsightProps} from "../ByTimeInsight/LineByTimeInsight";
import {BarByTimeInsight, BarByTimeInsightProps} from "../ByTimeInsight/BarByTimeInsight";
import {statisticsType, transportMethod} from "@ots-frontend/ots-data";
import {ActionIcon, Flex} from "@mantine/core";
import {IconSearch} from "@tabler/icons-react";

export type LoadsByTimeProps =
  Omit<(LineByTimeInsightProps | BarByTimeInsightProps), 'title' | 'xAxisTitle' | 'yAxisTitle' | 'statisticsTypes' | 'methods'>
  & {
  type?: 'bar' | 'line'
  showSearch?: boolean
}

export const LoadsByTimeInsights = (props: LoadsByTimeProps) => {
  const {
    type = 'bar',
    showSearch = false,
    ...rest
  } = props

  const {t} = useTranslation(["common"]);
  const navigate = useNavigate()

  if (type === 'bar') {
    return (
      <BarByTimeInsight
        {...rest}
        title={t<string>("common.insight.loadsbytime", "Loads By Time")}
        xAxisTitle={t<string>("common.insight.loadsbytime.xaxis.title", "Time")}
        yAxisTitle={t<string>("common.insight.loadsbytime.yaxis.title", "# of Loads")}
        statisticsTypes={statisticsType.loads}
        methods={transportMethod.trucking}>
        {showSearch &&
          <Flex justify="flex-end">
            <ActionIcon onClick={() => navigate("/insights/loads-by")}>
              <IconSearch size="1.125rem"/>
            </ActionIcon>
          </Flex>
        }
      </BarByTimeInsight>
    )
  } else {
    return (
      <LineByTimeInsight
        {...rest}
        title={t<string>("common.insight.loadsbytime", "Loads By Time")}
        xAxisTitle={t<string>("common.insight.loadsbytime.xaxis.title", "Time")}
        yAxisTitle={t<string>("common.insight.loadsbytime.yaxis.title", "# of Loads")}
        statisticsTypes={statisticsType.loads}
        methods={transportMethod.trucking}>
        {showSearch &&
          <Flex justify="flex-end">
            <ActionIcon onClick={() => navigate("/insights/loads-by")}>
              <IconSearch size="1.125rem"/>
            </ActionIcon>
          </Flex>
        }
      </LineByTimeInsight>
    )
  }
}
